import { useRef, useState } from 'react';
import { Badge, Col, Row } from 'rsuite';
import { CustomInput } from '../../../../components/CustomInput';
import { useCustomTheme } from '../../../../hooks/useCustomTheme';
import { FaPen, FaSave, FaTrashAlt } from 'react-icons/fa';
import api from '../../../../services/api';
import { useDrag, useDrop } from 'react-dnd';

export function Tamanho({
  item,
  handleSetTamanhos,
  tamanhos,
  moveCard,
  index,
}) {
  const { theme } = useCustomTheme();
  const [editTamanho, setEditTamanho] = useState(null);

  const tamanhoRef = useRef(null);

  const [{ handlerId }, drop] = useDrop({
    accept: 'tamanho',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!tamanhoRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      const hoverBoundingRect = tamanhoRef.current?.getBoundingClientRect();

      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY * 0.5) {
        return;
      }
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY * 1.5) {
        return;
      }
      moveCard(dragIndex, hoverIndex);

      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'tamanho',
    item: () => {
      return { Id: item.Id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(tamanhoRef));

  async function handleDeleteTamanho(item) {
    await api.patch(`/tamanho/alterar/${item.Id}`, {
      Ativo: false,
    });

    handleSetTamanhos((prev) => prev.filter((it) => it.Id !== item.Id));
  }

  async function handleSaveEdit(item) {
    await api.patch(`tamanho/alterar/${item.Id}`, {
      ...editTamanho,
    });

    handleSetTamanhos(() =>
      tamanhos?.map((tam) => (tam.Id === item.Id ? editTamanho : tam)),
    );
    setEditTamanho(null);
  }

  function handleEditTamanho(item) {
    setEditTamanho(item);
  }

  return (
    <Row
      key={item.Id}
      style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.colors.backgroundSecondary,
        padding: '6px 12px',
        borderRadius: '10px',
        marginBottom: '6px',
        cursor: isDragging ? 'grabbing' : 'grab',
      }}
      ref={tamanhoRef}
      data-handler-id={handlerId}
    >
      <Col
        xs={19}
        style={{
          color: theme.colors.text,
        }}
      >
        {editTamanho?.Id === item.Id ? (
          <CustomInput
            value={editTamanho?.Descricao}
            onChange={(newValue) =>
              setEditTamanho((prev) => ({
                ...prev,
                Descricao: newValue,
              }))
            }
          />
        ) : (
          item.Descricao
        )}
      </Col>
      <Col
        xs={3}
        style={{
          color: theme.colors.text,
        }}
      >
        <Badge
          color={item.Ativo ? 'green' : 'red'}
          content={item.Ativo ? 'Ativo' : 'Inativo'}
        />
      </Col>
      <Col
        xs={1}
        style={{
          color: theme.colors.text,
        }}
      >
        <div
          onClick={() =>
            editTamanho?.Id === item.Id
              ? handleSaveEdit(item)
              : handleEditTamanho(item)
          }
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          {editTamanho?.Id === item.Id ? (
            <FaSave color={theme.colors.success} />
          ) : (
            <FaPen color={theme.colors.text} />
          )}
        </div>
      </Col>
      <Col
        xs={1}
        style={{
          color: theme.colors.text,
        }}
      >
        <div
          onClick={() => handleDeleteTamanho(item)}
          style={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaTrashAlt color={theme.colors.danger} />
        </div>
      </Col>
    </Row>
  );
}
